/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetYoutubeIntegrationStatsCountryViewersQueryResponse, GetYoutubeIntegrationStatsCountryViewersPathParams, GetYoutubeIntegrationStatsCountryViewersQueryParams } from "../models/GetYoutubeIntegrationStatsCountryViewers";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getYoutubeIntegrationStatsCountryViewers } from "../axios/getYoutubeIntegrationStatsCountryViewers";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getYoutubeIntegrationStatsCountryViewersQueryKey = (station: GetYoutubeIntegrationStatsCountryViewersPathParams["station"], params: GetYoutubeIntegrationStatsCountryViewersQueryParams) => ["web-app-bff-api", { url: '/youtube-stats/viewers/:station/country', params: {station:station} }, ...(params ? [params] : [])] as const

export type GetYoutubeIntegrationStatsCountryViewersQueryKey = ReturnType<typeof getYoutubeIntegrationStatsCountryViewersQueryKey>

export function getYoutubeIntegrationStatsCountryViewersQueryOptions(station: GetYoutubeIntegrationStatsCountryViewersPathParams["station"], params: GetYoutubeIntegrationStatsCountryViewersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getYoutubeIntegrationStatsCountryViewersQueryKey(station, params)
        return queryOptions<GetYoutubeIntegrationStatsCountryViewersQueryResponse, ResponseErrorConfig<Error>, GetYoutubeIntegrationStatsCountryViewersQueryResponse, typeof queryKey>({
         enabled: !!(station&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return getYoutubeIntegrationStatsCountryViewers(station, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns stats for every channel in the live-viewers catalog whose `countryCode` matches this station’s channel. `metadata.channels[*].isSelf` marks this station’s `youtubeChannelId`.
 * @summary Viewer time series for same-country catalog channels
 * {@link /youtube-stats/viewers/:station/country}
 */
export function useGetYoutubeIntegrationStatsCountryViewers<TData = GetYoutubeIntegrationStatsCountryViewersQueryResponse, TQueryData = GetYoutubeIntegrationStatsCountryViewersQueryResponse, TQueryKey extends QueryKey = GetYoutubeIntegrationStatsCountryViewersQueryKey>(station: GetYoutubeIntegrationStatsCountryViewersPathParams["station"], params: GetYoutubeIntegrationStatsCountryViewersQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetYoutubeIntegrationStatsCountryViewersQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getYoutubeIntegrationStatsCountryViewersQueryKey(station, params)
         

         const query = useQuery({
          ...getYoutubeIntegrationStatsCountryViewersQueryOptions(station, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}